/**
 * Bonus Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    const core = require('core');
    const i18n = require('i18n');
    const Form = require('class/form.class');
    const device = require('util/device.util');
    const BaseReplacerView = require('common/base.replacer.view');
    const BonusCollection = require('replacers/bonus/bonus.collection');

    require('widgets/accordion.widget');

    module.exports = BaseReplacerView.extend({

        accessRules: {
            allow: ['user']
        },

        events: {
            'tap .fn-popup-open': 'onPopupOpen',
            'tap .fn-load-more': 'handleLoadMore',
            'tap .fn-cancel-bonus': 'onCancelBonusClick',
            'change .fn-status-filter': 'onStatusFilterChange'
        },

        subscribe: function() {
            this.listenTo(core, 'notification-bonus:updated', this._loadBonuses);
        },

        initialize: function(options) {
            this.params = options?.params || [];
            this.bonuses = new BonusCollection();
            this.attachWidget(this.$el.accordion());
        },

        render: function() {
            this.$el.html(this.tmpl('bonus.history'));
            this.form = new Form(this.$('form'));

            this._loadBonuses();

            return this;
        },

        _loadBonuses: function(clearBonuses = true) {
            this.form.showLoading();

            return this.bonuses.fetch({ remove: clearBonuses })
                .done(() => this._insertBonusHistory())
                .fail(() => this.renderNetworkError())
                .always(() => this.form.hideLoading());
        },

        _insertBonusHistory: function() {
            this.$('.fn-show-more').toggleClass('hidden', !this.bonuses.cachedPageId);
            this.el.querySelector('.fn-bonus-history').innerHTML = this.tmpl('bonus.list', {
                bonuses: this.bonuses.toJSON(),
                config: this.bonuses.bonusConfig,
                tcPreferences: this.bonuses.tcPreferences,
                showCancelButton: this.params.includes('showCancelButton')
            });
        },

        onPopupOpen: (e) => {
            e.preventDefault();
            const popupParams = e.target.dataset;

            if (Object.keys(popupParams).length > 0) {
                window.Playtech.API.popup.showPopup({
                    className: 'ts-bonusTcUrl-popup',
                    articleId: popupParams.articleId,
                    title: popupParams.title,
            });
            }
        },

        onCancelBonusClick: function(event) {
            const { bonusName, bonusInstanceCode } = event.currentTarget.dataset;

            event.preventDefault();

            if (!bonusInstanceCode) {
                return;
            }

            window.Playtech.API.popup.showPopup('confirmation', {
                title: i18n.t('playtech.mobile.system.bonusCancel.popup.title'),
                content: i18n.t('playtech.mobile.system.bonusCancel.popup.content') + ' ' + bonusName,
                isModal: true,
                acceptBtnText: i18n.t('playtech.mobile.system.bonusCancel.popup.button.confirm'),
                declineBtnText: i18n.t('playtech.mobile.system.bonusCancel.popup.button.cancel'),
                onAccept: () => this.bonuses.cancelBonus(bonusInstanceCode)
                    .done(() => window.Playtech.API.user.fetchBalance()
                        .then(() => {
                            this._loadBonuses();
                        }))
                    .fail((error) => this.showError(error)),
            });
        },

        handleLoadMore: function(event) {
            event.preventDefault();

            this._loadBonuses(false);
        },

        onStatusFilterChange: function(event) {
            this.bonuses.statusFilter = event.target.value;

            this._loadBonuses()
                .always(() => {
                    if (device.formFactor === 'desktop') {
                        this.$('.fn-status-filter')?.[0]?.focus();
                    }
                });
        }
    }, {
        nameOfReplacers: [
            'BONUS_DETAIL_BALANCE'
        ]
    });
});
